import { dispatch } from '@rematch/core';
import {
  subOrganizationTreeService,
  subOrganizationTreeListService,
  usersTreeService,
  usersTreeListService,
  organizationService,
  subOrganizationService,
  userTeamsService
} from '../../services/feathers.service';

const initialState = {
  nodes: [],
  teamUsersArray: [],
  userSuborganizationList: []

}

export default {
  state: initialState,
  reducers: {

    setOrgUnits(state, payload) {
      return {
        ...state,
        nodes: payload
      }
    },
    setTeamUsers(state, payload) {
      return {
        ...state,
        teamUsersArray: payload
      }
    },
    setTeamsForUser(state, payload) {
      return {
        ...state,
        userSuborganizationList: payload
      }
    },
    setCurrentOrganization(state, payload) {
      return {
        ...state,
        currentOrganization: payload
      }
    },
    clear() {
      return initialState
    }
  },
  effects: {
    async getOrgnizationUnitAsync(organizationId) {
      try {
        dispatch.organizationUnit.setError(null);
        const orgUnits = await subOrganizationTreeListService.get(organizationId);
        dispatch.organizationTab.dispatchOrgUnits(orgUnits);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        throw err;
      }
    },

    dispatchOrgUnits(payload) {
      dispatch.organizationTab.setOrgUnits(payload);
    },

    dispatchCurrOrganization(payload) {
      dispatch.organizationTab.setCurrentOrganization(payload);
    },
   async getCurrentOrganizationData(payload){
      let organizationServiceresult =  await organizationService.find({query: {  _id : payload }})
      await dispatch.organizationTab.dispatchCurrOrganization(organizationServiceresult.data[0]);
    },

    async getUsersTreeAsync(payload, state) {
      try {
        dispatch.organizationUnit.setError(null);
        const subOrgUsers = await usersTreeListService.find({ query: { id: payload.id, accountId: payload.accountId ,organisationId:state.app.selectedOrganisation.id ? state.app.selectedOrganisation.id : state.app.selectedOrganisation._id} });
        await dispatch.users.setUsersListData(subOrgUsers);
        let executiveArr = subOrgUsers.filter((user) => {
          return user.role === 'workspaceOwner'
        })
        let managerArr = subOrgUsers.filter((user) => {
          return user.role === 'Manager'
        })
        let memberArr = subOrgUsers.filter((user) => {
          return user.role === 'Member'
        })
        dispatch.users.setExecutiveList(executiveArr);
        dispatch.users.setManagerList(managerArr);
        dispatch.users.setMemberList(memberArr);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        throw err;
      }
    },
    async getSelectedSubOrgUsersAsync(subOrgId) {
      try {
        dispatch.organizationUnit.setError(null);
        const subOrgUsers = await subOrganizationService.find({
          query: {
            '_id': subOrgId,
            $populate: [{ path: 'members.accountUserId', populate: 'accountUserId', select: '_id firstName lastName profilePic email' }]
          }

        });
        dispatch.organizationTab.dispatchTeamUsers(subOrgUsers.data[0].members);
      } catch (err) {
        dispatch.organizationUnit.setError(err);
        throw err;
      }
    },

    dispatchTeamUsers(payload) {
      dispatch.organizationTab.setTeamUsers(payload);
    },

    async getSubTeamsForUserAsync(payload) {
      try {
        dispatch.organizationUnit.setError(null);
        const userSuborganizationListResult = await userTeamsService.find({ query: payload });
        dispatch.organizationTab.setTeamsDataForUser(userSuborganizationListResult);

      } catch (err) {
        dispatch.organizationUnit.setError(err);
        throw err;
      }
    },

    setTeamsDataForUser(payload) {
      dispatch.organizationTab.setTeamsForUser(payload);
    },

    clearOrganizationTab() {
      dispatch.organizationTab.clear();
    },
  }
}